<template>
  <div>
    <grid-view class="grid-view position-relative" />
  </div>
</template>

<script>
import GridView from "@/views/components/GridView";
import store from "@/store";

import setRoundCommand from "@/websockets/setRoundCommand";
import useAppConfig from '@core/app-config/useAppConfig';

export default {
  components: {
    GridView,
  },
  created() {
    setTimeout(() => {
      setRoundCommand(store);
    }, 2000)

  },
  mounted() {
    const { skin } = useAppConfig();

    if (skin.value === "dark") {
      document.body.classList.add("dark-layout");
    }

    //here we load the view from the query params apply layout by id or unit and view type

    this.$nextTick(() => {
      let query = this.$route.query;
      if (Object.keys(query).length === 0 && typeof window !== 'undefined' && window.location.hash) {
        const hash = window.location.hash;
        const queryStart = hash.indexOf('?');
        if (queryStart !== -1) {
          const params = new URLSearchParams(hash.slice(queryStart));
          query = Object.fromEntries(params.entries());
        }
      }
      const unitId = query.unit;
      const viewType = query.viewType;
      const viewId = query.view;
      if (viewType && (unitId || (viewType === 'layout' && viewId))) {
        this.$store.dispatch("grid/getUnitsByTenant")
          .catch(() => {})
          .then(() => {
            return this.$store.dispatch("grid/loadViewFromQuery", {
              unitId,
              viewType,
              viewId,
            });
          })
          .finally(() => {
            this.$router.replace({ path: "/inicio", query: {} });
          });
      }
    });
  },
  setup() {
    const {skin } = useAppConfig();

    return {
      skin,
    };
  },
};
</script>